import RRule from 'rrule';
import { SelectOptionsType } from '../views/giveinkind/components/Select';

export const legacyAppClassName = 'legacy-react-app';

export const repeatOptions = [
  { label: 'Does not repeat', value: -1 },
  { label: 'Daily', value: RRule.DAILY },
  { label: 'Weekly', value: RRule.WEEKLY },
  { label: 'Monthly', value: RRule.MONTHLY },
  { label: 'Custom', value: 10 },
];

export const repeatEveryOptions = [
  { label: 'Day(s)', value: RRule.DAILY },
  { label: 'Week(s)', value: RRule.WEEKLY },
  { label: 'Month(s)', value: RRule.MONTHLY },
];

export const endsOptions = [
  { label: 'On', value: 'on' },
  { label: 'After', value: 'after' },
];

export const addToCalendarOptions: SelectOptionsType<number>[] = [
  { label: 'Google', value: 1, icon: 'icon-v2-google' },
  { label: 'Outlook/Apple', value: 2, icon: 'icon-v2-outlookApple' },
];
